import React from "react";
import { EmploymentStatusContainer } from "../../../containers";

const EmploymentStatus = (props) => {
  return <EmploymentStatusContainer {...props} />;
};

export default EmploymentStatus;
